import { render } from "./Logo.vue?vue&type=template&id=59f201b6"
import script from "./Logo.vue?vue&type=script&lang=js"
export * from "./Logo.vue?vue&type=script&lang=js"
script.render = render

export default script